import React, { useState, Children, Component } from 'react';
import { HeartIcon, MessageSquareIcon, ShareIcon, UserPlusIcon, GlobeIcon, DollarSignIcon, HandIcon, BarChartIcon, UsersIcon, HomeIcon, DropletIcon, BookOpenIcon, HeartPulseIcon, PlusIcon, XIcon, FacebookIcon, TwitterIcon, LinkedinIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
export function SocialFeed() {
  const [sharePopupOpen, setSharePopupOpen] = useState<number | null>(null);
  const charities = [{
    id: 1,
    organization: {
      name: 'Cancer Research Foundation',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      verified: true
    },
    title: 'Research Grant for Early Detection',
    content: 'Help us fund groundbreaking research for early cancer detection methods. Your donation directly supports scientists working on innovative screening technologies.',
    goalAmount: 50000,
    raisedAmount: 32450,
    daysLeft: 18,
    donors: 246,
    shares: 128
  }, {
    id: 2,
    organization: {
      name: 'Clean Water Initiative',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      verified: true
    },
    title: 'Wells for Rural Communities',
    content: "We're building 10 new wells in communities facing severe water shortages. Each well provides clean water to approximately 200 people daily.",
    goalAmount: 25000,
    raisedAmount: 16780,
    daysLeft: 24,
    donors: 189,
    shares: 95
  }, {
    id: 3,
    organization: {
      name: 'Education For All',
      avatar: 'https://via.placeholder.com/40/754acd/FFFFFF?text=E',
      verified: true
    },
    title: 'School Supplies for 500 Children',
    content: 'Your donation helps provide essential school supplies to children from low-income families, ensuring they have the tools they need to succeed in their education.',
    goalAmount: 15000,
    raisedAmount: 9250,
    daysLeft: 12,
    donors: 156,
    shares: 82
  }];
  const suggestedCharities = [{
    id: 1,
    name: 'Heart Health Alliance',
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
    category: 'Health',
    supporters: 12450
  }, {
    id: 2,
    name: 'Wildlife Protection Fund',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    category: 'Environment',
    supporters: 8320
  }, {
    id: 3,
    name: "Children's Education Trust",
    avatar: 'https://randomuser.me/api/portraits/women/89.jpg',
    category: 'Education',
    supporters: 15670
  }];
  const handleShare = (charity: (typeof charities)[0], platform: string) => {
    const url = window.location.href;
    const text = `${charity.title} - ${charity.organization.name}. Help us raise £${charity.goalAmount.toLocaleString()}!`;
    let shareUrl = '';
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${encodeURIComponent(charity.title)}&body=${encodeURIComponent(text + '\n\n' + url)}`;
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
      setSharePopupOpen(null);
    }
  };
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-584">
      <div className="lg:col-span-2 space-y-6" data-id="element-585">
        <div className="bg-card rounded-xl shadow-sm p-4" data-id="element-586">
          <div className="flex space-x-3" data-id="element-587">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary to-secondary flex items-center justify-center text-white font-bold" data-id="element-588">
              JD
            </div>
            <input type="text" placeholder="Share a charity or cause you care about..." className="flex-1 bg-gray-100 rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50" data-id="element-589" />
          </div>
          <div className="flex justify-between mt-4 pt-3 border-t border-gray-100" data-id="element-590">
            <button className="flex items-center text-text-secondary text-sm font-medium" data-id="element-591">
              <GlobeIcon className="w-4 h-4 mr-1" data-id="element-592" />
              Public
            </button>
            <button className="bg-primary text-white px-4 py-1.5 rounded-lg text-sm font-medium" data-id="element-593">
              Share
            </button>
          </div>
        </div>
        {charities.map(charity => <div key={charity.id} className="bg-card rounded-xl shadow-sm p-4 relative" data-id="element-594">
            <div className="flex justify-between" data-id="element-595">
              <div className="flex space-x-3" data-id="element-596">
                <img src={charity.organization.avatar} alt={charity.organization.name} className="w-10 h-10 rounded-full" onError={e => {
              e.currentTarget.src = 'https://via.placeholder.com/40/754acd/FFFFFF?text=' + charity.organization.name.charAt(0);
            }} data-id="element-597" />
                <div data-id="element-598">
                  <div className="flex items-center" data-id="element-599">
                    <p className="font-medium text-text-primary" data-id="element-600">
                      {charity.organization.name}
                    </p>
                    {charity.organization.verified && <span className="ml-1 text-xs bg-primary/10 text-primary px-1.5 py-0.5 rounded" data-id="element-601">
                        Verified
                      </span>}
                  </div>
                  <p className="text-xs text-text-muted" data-id="element-602">
                    {charity.daysLeft} days left
                  </p>
                </div>
              </div>
              <button className="text-text-muted hover:text-text-primary" data-id="element-603">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-604">
                  <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" data-id="element-605" />
                </svg>
              </button>
            </div>
            <div className="mt-3" data-id="element-606">
              <h3 className="font-bold text-lg text-text-primary" data-id="element-607">
                {charity.title}
              </h3>
              <p className="text-text-primary mt-1" data-id="element-608">{charity.content}</p>
            </div>
            <div className="mt-4" data-id="element-609">
              <div className="flex justify-between mb-1" data-id="element-610">
                <span className="text-sm font-medium text-text-primary" data-id="element-611">
                  £{charity.raisedAmount.toLocaleString()} raised
                </span>
                <span className="text-sm font-medium text-text-primary" data-id="element-612">
                  of £{charity.goalAmount.toLocaleString()}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-613">
                <div className="bg-gradient-to-r from-primary to-secondary h-2.5 rounded-full" style={{
              width: `${charity.raisedAmount / charity.goalAmount * 100}%`
            }} data-id="element-614"></div>
              </div>
            </div>
            <div className="flex justify-between mt-4 pt-3 border-t border-gray-100 text-sm" data-id="element-615">
              <div className="flex space-x-1 text-text-muted" data-id="element-616">
                <UsersIcon className="w-4 h-4" data-id="element-617" />
                <span data-id="element-618">{charity.donors} donors</span>
              </div>
              <div className="flex space-x-3 text-text-muted" data-id="element-619">
                <span data-id="element-620">{charity.shares} shares</span>
              </div>
            </div>
            <div className="flex justify-between mt-3 pt-3 border-t border-gray-100" data-id="element-621">
              <button className="flex items-center justify-center space-x-1 flex-1 py-1.5 text-text-secondary hover:bg-gray-50 rounded" data-id="element-622">
                <HeartIcon className="w-4 h-4" data-id="element-623" />
                <span className="text-sm font-medium" data-id="element-624">Support</span>
              </button>
              <button className="flex items-center justify-center space-x-1 flex-1 py-1.5 bg-primary text-white hover:bg-primary/90 rounded" data-id="element-625">
                <DollarSignIcon className="w-4 h-4" data-id="element-626" />
                <span className="text-sm font-medium" data-id="element-627">Donate</span>
              </button>
              <button onClick={() => setSharePopupOpen(sharePopupOpen === charity.id ? null : charity.id)} className="flex items-center justify-center space-x-1 flex-1 py-1.5 text-text-secondary hover:bg-gray-50 rounded" data-id="element-628">
                <ShareIcon className="w-4 h-4" data-id="element-629" />
                <span className="text-sm font-medium" data-id="element-630">Share</span>
              </button>
            </div>
            {sharePopupOpen === charity.id && <div className="absolute bottom-16 right-4 bg-white rounded-xl shadow-lg border border-gray-200 p-4 z-10 w-64" data-id="element-631">
                <div className="flex items-center justify-between mb-3" data-id="element-632">
                  <h3 className="font-semibold text-text-primary" data-id="element-633">
                    Share this cause
                  </h3>
                  <button onClick={() => setSharePopupOpen(null)} className="text-text-muted hover:text-text-primary" data-id="element-634">
                    <XIcon className="w-4 h-4" data-id="element-635" />
                  </button>
                </div>
                <div className="grid grid-cols-3 gap-3" data-id="element-636">
                  <button onClick={() => handleShare(charity, 'facebook')} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-637">
                    <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center mb-1" data-id="element-638">
                      <FacebookIcon className="w-5 h-5 text-white" data-id="element-639" />
                    </div>
                    <span className="text-xs text-text-secondary" data-id="element-640">
                      Facebook
                    </span>
                  </button>
                  <button onClick={() => handleShare(charity, 'twitter')} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-641">
                    <div className="w-10 h-10 rounded-full bg-black flex items-center justify-center mb-1" data-id="element-642">
                      <TwitterIcon className="w-5 h-5 text-white" data-id="element-643" />
                    </div>
                    <span className="text-xs text-text-secondary" data-id="element-644">Twitter</span>
                  </button>
                  <button onClick={() => handleShare(charity, 'linkedin')} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-645">
                    <div className="w-10 h-10 rounded-full bg-blue-700 flex items-center justify-center mb-1" data-id="element-646">
                      <LinkedinIcon className="w-5 h-5 text-white" data-id="element-647" />
                    </div>
                    <span className="text-xs text-text-secondary" data-id="element-648">
                      LinkedIn
                    </span>
                  </button>
                  <button onClick={() => handleShare(charity, 'whatsapp')} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-649">
                    <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center mb-1" data-id="element-650">
                      <MessageCircleIcon className="w-5 h-5 text-white" data-id="element-651" />
                    </div>
                    <span className="text-xs text-text-secondary" data-id="element-652">
                      WhatsApp
                    </span>
                  </button>
                  <button onClick={() => handleShare(charity, 'email')} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-653">
                    <div className="w-10 h-10 rounded-full bg-gray-600 flex items-center justify-center mb-1" data-id="element-654">
                      <MailIcon className="w-5 h-5 text-white" data-id="element-655" />
                    </div>
                    <span className="text-xs text-text-secondary" data-id="element-656">Email</span>
                  </button>
                </div>
              </div>}
          </div>)}
      </div>
      <div className="space-y-6" data-id="element-657">
        <div className="bg-card rounded-xl shadow-sm" data-id="element-658">
          <div className="p-4 border-b border-gray-100" data-id="element-659">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-660">
              Charities to Support
            </h2>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-661">
            {suggestedCharities.map(charity => <div key={charity.id} className="p-4 flex items-center justify-between" data-id="element-662">
                <div className="flex items-center" data-id="element-663">
                  <img src={charity.avatar} alt={charity.name} className="w-10 h-10 rounded-full mr-3" onError={e => {
                e.currentTarget.src = 'https://via.placeholder.com/40?text=' + charity.name.charAt(0);
              }} data-id="element-664" />
                  <div data-id="element-665">
                    <p className="font-medium text-text-primary" data-id="element-666">
                      {charity.name}
                    </p>
                    <p className="text-xs text-text-muted" data-id="element-667">
                      {charity.supporters.toLocaleString()} supporters
                    </p>
                  </div>
                </div>
                <button className="flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1.5 rounded-lg text-sm font-medium" data-id="element-668">
                  <UserPlusIcon className="w-4 h-4" data-id="element-669" />
                  <span data-id="element-670">Follow</span>
                </button>
              </div>)}
          </div>
        </div>
        <div className="bg-card rounded-xl shadow-sm p-4" data-id="element-671">
          <h2 className="text-lg font-semibold text-text-primary mb-3" data-id="element-672">
            Charitable Categories
          </h2>
          <div className="space-y-3" data-id="element-673">
            <button className="w-full flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100" data-id="element-674">
              <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3" data-id="element-675">
                <HeartPulseIcon className="h-5 w-5" data-id="element-676" />
              </div>
              <div className="text-left" data-id="element-677">
                <p className="font-medium text-text-primary" data-id="element-678">
                  Health & Medical
                </p>
                <p className="text-xs text-text-muted" data-id="element-679">524 charities</p>
              </div>
            </button>
            <button className="w-full flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100" data-id="element-680">
              <div className="w-10 h-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center mr-3" data-id="element-681">
                <DropletIcon className="h-5 w-5" data-id="element-682" />
              </div>
              <div className="text-left" data-id="element-683">
                <p className="font-medium text-text-primary" data-id="element-684">
                  Water & Sanitation
                </p>
                <p className="text-xs text-text-muted" data-id="element-685">238 charities</p>
              </div>
            </button>
            <button className="w-full flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100" data-id="element-686">
              <div className="w-10 h-10 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center mr-3" data-id="element-687">
                <BookOpenIcon className="h-5 w-5" data-id="element-688" />
              </div>
              <div className="text-left" data-id="element-689">
                <p className="font-medium text-text-primary" data-id="element-690">Education</p>
                <p className="text-xs text-text-muted" data-id="element-691">356 charities</p>
              </div>
            </button>
            <button className="w-full flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100" data-id="element-692">
              <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mr-3" data-id="element-693">
                <div className="h-5 w-5" data-id="element-694" />
              </div>
              <div className="text-left" data-id="element-695">
                <p className="font-medium text-text-primary" data-id="element-696">Environment</p>
                <p className="text-xs text-text-muted" data-id="element-697">189 charities</p>
              </div>
            </button>
          </div>
          <button className="w-full mt-3 text-primary text-sm font-medium py-2 flex items-center justify-center" data-id="element-698">
            <PlusIcon className="w-4 h-4 mr-1" data-id="element-699" />
            Explore More Categories
          </button>
        </div>
      </div>
    </div>;
}